import SplashScreen from 'pages/SubscriptionReturn/Success/SplashScreen';

const SubscriptionPendingSplashScreen = () => <SplashScreen />;

export default SubscriptionPendingSplashScreen;
